import React, { useEffect } from 'react';
import ActionButton from '../components/layout/actionButtons';
import CalendarService from "../services/calendar";
import UserService from "../services/users";
import CalendarView from '../components/calendar/view'; 
import CalenderEdit from '../components/calendar/edit';
import { IconButton, Tab, Tabs } from '@material-ui/core';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';

export default function Kalendar(props) {
    const [items, setItems] = React.useState([]);
    const [item, setItem] = React.useState(undefined);
    const [archive, setArchive] = React.useState([])
    const [readOnly, setReadOnly] = React.useState(true);
    const currentUser = UserService.currentUser();
    const [selectedStatus, setSelectedStatus] = React.useState(0);

    const   sortJSON = (data, key, way) =>{
  return data.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      if (way === '123') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }
      if (way === '321') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
  });
}

    useEffect(() => {
        setReadOnly(currentUser.adminmodules.find(mod => { return mod === 'calendar' }) === undefined);

        UserService.validSecuritySession()
            .then(
                (result) => {

                }, (error) => {
                    props.history.push('/login');
                })

        if (!props.match.params.id) {
            CalendarService.get().then(
                (result) => {
                    setItems(result.filter(item => { return item.end >= moment().format('YYYY-MM-DD') }));
                    let tmpArchive = result.filter(item => { return item.end < moment().format('YYYY-MM-DD') });
                    tmpArchive = tmpArchive.map(item => {
                        item.start = moment(item.start).format('YYYY-MM-DD HH:mm');
                        item.end = moment(item.end).format('YYYY-MM-DD HH:mm');
                        return item;
                    })
                    tmpArchive = sortJSON(tmpArchive,'start','321');
                    setArchive(tmpArchive);
                },
                (err) => {
                    props.handleMessage({ title: "Kan de gegevens niet ophalen" });
                    props.history.push('/calendar')
                }
            )

        } else {
            if (props.match.params.id === '0') {
                setItem({ start: new Date(), end: new Date(), title: '', description: '', active: true });
            } else {
                CalendarService.get(props.match.params.id).then(
                    (result) => {
                        setItem(result);
                    },
                    (err) => {
                        props.handleMessage({ title: "Kan de gegevens niet ophalen" });
                        props.history.push('/calendar')
                    }
                )
            }

        }

    }, [])

    useEffect(() => {
        if (!props.match.params.id) {
            let actionButtons;
            if (currentUser.adminmodules.find(mod => { return mod === 'calendar' }) !== undefined) {
                actionButtons = <ActionButton {...props} linkNewItem='/calendar/0'></ActionButton>

            }
            props.handleMenu(
                {
                    title: 'Kalender',
                    showBackButton: false,
                    handleActions: actionButtons
                })
        } else {
            let actionButtons;
            let deleteButton = <IconButton onClick={() => { window.confirm("Weet u zeker dat u dit bericht wilt verwijderen?") && handleDelete(item) }}><DeleteIcon style={{ color: 'FFF' }} /></IconButton>

            actionButtons = <ActionButton {...props} handleSave={handleSave} itemleft={<React.Fragment>{deleteButton}</React.Fragment>}></ActionButton>

            props.handleMenu(
                {
                    title: 'Kalender',
                    showBackButton: true,
                    handleActions: actionButtons
                })
        }
    }, [item]);

    const handleDelete = () => {

        CalendarService.delete(item._id).then(
            (result) => {
                props.handleMessage({ title: "De gegevens zijn verwijderd" });
                setItem(undefined);
                props.history.push('/calendar');
            },
            (err) => {
                props.handleMessage({ title: "Er is een fout opgetreden bij het verwijderen van de gegevens" });
            }
        )
    }
    const handleSave = () => {

        CalendarService.save(item).then(
            (result) => {
                props.handleMessage({ title: "De gegevens zijn opgeslagen" });
                setItem(result);
                props.history.push('/calendar');
            },
            (err) => {
                props.handleMessage({ title: "Er is een fout opgetreden bij het opslaan van de gegevens" });
            }
        )
    }

    const handleChange = (item) => {

        setItem(item)
    }

    return (
        <div className="padding">
            {item && <CalenderEdit item={item} onChange={handleChange} />}
            {!item && <Tabs value={selectedStatus} onChange={(ev,val) => {setSelectedStatus(val) }}>
                <Tab label={'Actueel'} />
                <Tab label={'Archief'} />
            </Tabs>}
            {!item && selectedStatus==0 && <CalendarView items={items} readOnly={readOnly} history={props.history} />}
            {!item &&selectedStatus==1 &&  <CalendarView items={archive} readOnly={readOnly} history={props.history} />}

        </div>
    )
}